module.exports = __webpack_public_path__ + "media/src/images/site-top/member-image-c8adb79c87352d537de52f1fa049736c.jpg";